import { useEvent } from "shared/lib/useEvent"

import { useUpdateProject } from "entities/projects/api/useUpdateProject"
import { TeamRole } from "entities/team-members/types/TeamRole"
import { useProject } from "features/project-management/model/useProject"
import { useProjectStore } from "features/project-management/model/useProjectStore"
import { ProjectFormData } from "features/project-management/types/ProjectFormData"
import { ProjectFormTabType } from "features/project-management/types/ProjectFormTabType"

import { ProjectPageProjectSidebarModel } from "../ProjectPageProjectSidebar"

export interface UseProjectPageProjectSidebarModelArgs {
  projectID: string
}

export function useProjectPageProjectSidebarModel({
  projectID
}: UseProjectPageProjectSidebarModelArgs): ProjectPageProjectSidebarModel {
  const {
    sidebarIsEditing,
    sidebarActiveTab,
    enterSidebarEditing,
    exitSidebarEditing,
    setSidebarActiveTab
  } = useProjectStore(projectID)
  const model = useProject(
    { projectID },
    {
      includePrice: sidebarActiveTab === ProjectFormTabType.PRICES,
      includeTeam: true
    }
  )
  const { updateProject } = useUpdateProject()

  const handleSubmit = useEvent(async (formData: ProjectFormData) => {
    model.clarificationRequest?.handlers.onSubmitContent?.(
      formData.clarificationRequest?.content
    )
    const result = await updateProject(projectID, formData.project)
    const errors = result?.errors ?? []
    return { data: {}, errors: errors.length ? errors : undefined }
  })

  return {
    projectID,
    model,
    onSubmit: handleSubmit,
    hideControls: model.core.data.role?.data === TeamRole.READ,
    isEditing: sidebarIsEditing,
    enterEditing: enterSidebarEditing,
    exitEditing: exitSidebarEditing,
    sidebarActiveTab,
    setSidebarActiveTab
  }
}
